import template from './assetDetails.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    quickQuoteAssetDetails: '<',
    assetDetails: '<',
    validationErrors: '<',
    additionalProduct: '<',
    financeProposal: '<',
    searchFields: '<',
    lenders: '<',
    countries: '<',
    idTicket: '<',
    isCommercial: '<',
    isUnsecured: '<',
    isTicketSettled: '<',
    onToggleUnsecured: '&',
    onValidated: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      $timeout,
      Address,
      AssetFinanceDetail,
      AssetFinanceProposal,
      helperService,
      assetFinanceService,
      contactService,
      contactsService,
      Contact,
      CompanyIndividual,
      ContactCompanyType,
      PersonalTitle,
      searchService,
      uiService,
      eventService,
      financesService,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableAssetAges = [];
      ctrl.validationErrors = ctrl.validationErrors || [];
      ctrl.availableAssetTypes = [];
      ctrl.availableCarTypes = [];
      ctrl.availableYears = [];
      ctrl.availableVendorTypes = [];
      ctrl.availableStates = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availablePersonalTitles = [];
      ctrl.googleAutocompleteOptions = null;
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;
      ctrl.searchTerm = '';
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableAssetAges = assetFinanceService.getAvailableAssetAges();
        ctrl.availableCarTypes = assetFinanceService.getAvailableCarTypes();
        ctrl.availableYears = helperService.getAvailableYears({ isTaxYear: false });
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: false
        });
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.quickQuoteAssetDetails = ctrl.quickQuoteAssetDetails || [];
        ctrl.assetDetails = ctrl.assetDetails || [];
        ctrl.additionalProduct = ctrl.additionalProduct || {};
        ctrl.financeProposal = ctrl.financeProposal || {};
        ctrl.searchFields = ctrl.searchFields || {};
        ctrl.lenders =
          _.chain(ctrl.lenders)
            .filter((l) => l.type.indexOf('ASSET_FINANCE') > -1)
            .sortNatural('name')
            .sortNatural('group')
            .value() || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isUnsecured = ctrl.isUnsecured || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableAssetTypes = assetFinanceService.getAvailableAssetTypes(
          ctrl.isCommercial,
          false
        );
        ctrl.availableVendorTypes = assetFinanceService.getAvailableVendorTypes({
          isSearch: false,
          isCommercial: ctrl.isCommercial
        });
        if (!ctrl?.assetDetails?.length && !ctrl.isUnsecured) {
          ctrl.assetDetailsAdd({ isEmpty: true });
        }
        if (!ctrl.financeProposal?.totalAssetCost || !ctrl.financeProposal?.totalAssetNetCost) {
          ctrl.isProcessing = true;
          ctrl.assetFinanceAssetDetailsEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.assetDetailsAdd = ({ isEmpty }) => {
        if (!ctrl.isUnsecured) {
          ctrl.assetDetails = assetFinanceService.assetDetailsAdd({
            assetDetails: ctrl.assetDetails,
            quickQuoteAssetDetails: isEmpty ? ctrl.quickQuoteAssetDetails : []
          });
          if (isEmpty) {
            ctrl.assetDetailChanges();
          }
        }

        ctrl.onValidated();
      };

      ctrl.assetDetailsDelete = (asset) => {
        helperService
          .deleteItem(ctrl.assetDetails, asset, asset.getName(), 'Asset')
          .then((result) => {
            if (result) {
              ctrl.assetDetailChanges();
            }
          });
      };

      ctrl.assetDetailPpsrChanges = (asset) => {
        if (asset) {
          const idx = _.findIndex(ctrl.assetDetails || [], (a) => a?.id === asset?.id);
          if (idx > -1) {
            ctrl.assetDetails.splice(idx, 1);
            ctrl.assetDetails.splice(idx, 0, asset);
            ctrl.assetDetailChanges(true);
          }
        }
      };

      ctrl.assetDetailChange = ({ assetDetail, action }) => {
        ctrl.assetDetails = assetFinanceService.assetDetailChange({
          assetDetails: ctrl.assetDetails,
          assetDetail,
          action,
          isCommercial: ctrl.isCommercial
        });
        if (action === 'vendorType' && !assetDetail?.vendor?.type) {
          ctrl.searchVendorName = '';
        }
        ctrl.assetDetailChanges(action === 'vendorType');
      };

      ctrl.showMileageOrHours = ({ assetType, isMileage }) =>
        assetFinanceService.showAssetDetailMileageOrHours({
          assetType,
          isCommercial: ctrl.isCommercial,
          isMileage
        });

      ctrl.searchContact = (query) => searchService.getContacts({ query, isCompany: true });

      ctrl.changeSelectedItemOfVendor = _.debounce((assetToUpdate, selectedContact) => {
        if (selectedContact) {
          assetFinanceService
            .changeSelectedItemOfVendor({ assetToUpdate, selectedContact })
            .then((asset) => {
              const idx = helperService.findIndexById(ctrl.assetDetails, asset.id);
              if (idx > -1) {
                ctrl.assetDetails[idx] = asset;
                ctrl.changeVendorDetails(asset, idx);
                ctrl.assetDetailChanges();
              }
            });
        }
      }, 1500);

      ctrl.changeVendorDetails = _.debounce((asset, idx) => {
        let name = ctrl.searchVendorName;
        if (!_.isString(name)) {
          name = ctrl.searchVendorName?.name || '';
        }
        if (asset && asset?.vendor?.idContact && _.isString(name) && name !== '') {
          contactService.readContact({ id: asset?.vendor?.idContact }).then((result) => {
            const contact = result;
            if (name !== contact?.company?.information?.name) {
              contact.company.information.name = name;
            }
            contact.company.information.refNumber = asset?.vendor?.entityNumber || '';
            contact.company.contact.phoneCode = asset?.vendor?.phoneCode || '';
            contact.company.contact.phone = asset?.vendor?.phone || '';
            contact.company.contact.faxCode = asset?.vendor?.faxCode || '';
            contact.company.contact.fax = asset?.vendor?.fax || '';
            contact.company.contact.email = asset?.vendor?.email || '';
            if (!contact?.company?.information?.individuals?.length) {
              contact.company.information.individuals = [CompanyIndividual.blank()];
            }
            contact.company.information.individuals[0].title =
              asset?.vendor?.contactTitle || PersonalTitle.none;
            contact.company.information.individuals[0].firstName =
              asset?.vendor?.contactFirstName || '';
            contact.company.information.individuals[0].familyName =
              asset?.vendor?.contactSurname || '';
            contact.company.contact.address = asset?.vendor?.address || Address.blank();
            contactService.updateContact(contact).then((data) => {
              contactsService.clearCache();
              if (data.status) {
                const aIdx = helperService.findIndexById(ctrl.assetDetails, asset.id);
                if (aIdx > -1) {
                  ctrl.assetDetails[aIdx] = asset;
                  ctrl.assetDetailChanges(true);
                }
              }
            });
          });
        } else if (
          asset &&
          !asset?.vendor?.idContact &&
          idx > -1 &&
          _.isString(name) &&
          name !== ''
        ) {
          const newContact = Contact.blank();
          newContact.isCompany = true;
          newContact.company.information.name = name;
          newContact.company.information.typeOfBusinessEntity = ContactCompanyType.ltd;
          contactService.createContact(newContact).then((result) => {
            if (result.status) {
              ctrl.assetDetails[idx].vendor.idContact = result.id;
              ctrl.assetDetails[idx].vendor.name = name;
              contactsService.clearCache();
              ctrl.assetDetailChanges(true);
            }
          });
        }
      }, 1500);

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.toggleUnsecured = () => {
        ctrl.onToggleUnsecured({ isUnsecured: ctrl.isUnsecured });
      };

      ctrl.isLenderSelected = (asset) =>
        helperService.isLenderSelected({ lenders: ctrl.lenders, lender: asset?.trade?.lender });

      ctrl.showLeaseWarning = () =>
        ctrl.isCommercial && !assetFinanceService.canSelectLease(ctrl.assetDetails);

      ctrl.isLeaseSelectedAsProductType = () =>
        assetFinanceService.isLeaseSelectedAsProductType({
          item: ctrl.searchFields,
          isAssetDetails: true
        });

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.getAssetDetailById = ({ assetDetails, id }) =>
        _.find(assetDetails || [], (a) => a?.id === id);

      ctrl.assetFinanceAssetDetailsEstimate = () => {
        financesService
          .assetFinanceAssetDetails({ idTicket: ctrl.idTicket, isQuote: false })
          .then((res) => {
            if (res?.status) {
              const len = ctrl.assetDetails?.length || 0;
              for (let a = 0; a < len; a += 1) {
                const assetDetail = ctrl.assetDetails[a];
                const resAssetDetail = ctrl.getAssetDetailById({
                  assetDetails: res?.assetDetails?.assetDetails || [],
                  id: assetDetail?.id || ''
                });
                if (resAssetDetail) {
                  assetDetail.calculatedDeposit = resAssetDetail?.calculatedDeposit || 0;
                  assetDetail.netCost = resAssetDetail?.netCost || 0;
                  assetDetail.trade.balance = resAssetDetail?.tradeBalance || 0;
                }
              }
              ctrl.financeProposal.totalAssetCost = res?.assetDetails?.totalAssetCost || 0;
              ctrl.financeProposal.totalAssetNetCost =
                res?.assetDetails?.totalAssetNetCost || 0;
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.assetDetailChanges = _.debounce((isSilent) => {
        ctrl.saveAssetDetails(isSilent);
      }, 3000);

      ctrl.saveAssetDetails = (isSilent) => {
        ctrl.isProcessing = !isSilent;
        const data = {
          assetDetails: ctrl.assetDetails,
          financeProposal: ctrl.financeProposal,
          additionalProduct: ctrl.additionalProduct,
          isUnsecured: ctrl.isUnsecured,
          aFCD: !isSilent ? 'assetFinanceAssetDetails' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceAssetDetails') {
          ctrl.assetFinanceAssetDetailsEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
